<div class="message-container" [style.display]="!show ? 'none' : 'flex'">
  <span class="message">{{ 'message-alert.message' | translate }}</span>
  <span class="question">{{ 'message-alert.question' | translate }}</span>
  <div style="display: flex; gap: 10px">
    <a (click)="close()">{{ 'message-alert.dismiss' | translate }}</a>  
    <a (click)="goTo()">{{ 'message-alert.start_now' | translate }}</a>
  </div>
</div>
